import { Navigate, Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';

// Rol bazlı route koruması
// allowedRoles: İzin verilen roller dizisi
// Örn: ['admin'] = sadece admin, ['admin', 'sef'] = ikisi de
const RoleProtectedRoute = ({ allowedRoles }) => {
    const { isAuthenticated, role } = useSelector((state) => state.auth);

    if (!isAuthenticated) {
        return <Navigate to="/giris" replace />;
    }

    // Rol kontrolü
    if (allowedRoles && !allowedRoles.includes(role)) {
        // Yetkisiz erişim - uygun modüle yönlendir
        if (role === 'sef') {
            return <Navigate to="/insaat/ozet" replace />;
        }
        return <Navigate to="/finans/ozet" replace />;
    }

    return <Outlet />;
};

export default RoleProtectedRoute;
